<template>
	<div class="work">
		<el-row :gutter="20">
			<el-col :span="24" class="shadow">
				<div>
					<div class="filter-container">
					    <el-input placeholder="请输入机器人ID" v-model="listQuery.params.car_id" style="width: 360px" class="filter-item"></el-input>
						<el-input placeholder="请输入作业名称" v-model="listQuery.params.mission_name" 
							class="filter-item" style="width: 360px;margin-left: 20px;"></el-input>
							<el-input placeholder="请输入单位名称" v-model="listQuery.params.entity_name"
								class="filter-item" style="width: 360px;margin-left: 20px;"></el-input>
					    <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleFilter(true)">
					      搜索
					    </el-button>
					</div>
					<el-table
						:data="worklst"
						v-loading="listLoading"
						border
						highlight-current-row
						style="width: 100%;align: center;">
						<!-- <el-table-column prop="id" label="序号" width="60px" align="center"> </el-table-column> -->
						<el-table-column prop="carName" label="机器人名称" align="center"  width="200"> </el-table-column>
						<el-table-column prop="carId" label="机器人ID" align="center"  width="200"> </el-table-column>
						<el-table-column prop="entityName" label="运营单位" align="center"  width="200"> </el-table-column>
						<el-table-column prop="missionName" label="作业名称" align="center" width="110"></el-table-column>
						<el-table-column prop="missionFunc" label="作业功能" align="center" width="100"></el-table-column>
						<el-table-column prop="missionRe" label="作业模式" align="center" width="100"></el-table-column>
						<el-table-column prop="missionTime" label="作业时间" align="center" width="85" ></el-table-column>
						<el-table-column prop="missionMap" label="作业地图" align="center"></el-table-column>
						<el-table-column prop="missionTrack" label="作业轨迹" align="center"></el-table-column>
						<el-table-column prop="recordStatusStr" label="数据可用" align="center"></el-table-column>
						<el-table-column prop="operator" label="操作" align="center">
						    <template v-slot:="{row,$index}">
						      <el-button type="success" size="mini" @click="handleMissionExecute(row)">
						        执行
						      </el-button>
							  <el-button type="primary" size="mini" @click="handleMqttPush(row)"
									> <!-- :style="{ display: row.carId.substring(0,1) == 8?'':'none' }" -->
								推送
							  </el-button>
							  <el-button v-if="row.recordStatus == 0" type="warning" size="mini" @click="handleMissionHide(row,1)">
								隐藏
							  </el-button>
							  <el-button v-if="row.recordStatus == 1" type="warning" size="mini" @click="handleMissionHide(row,0)">
							  	启用
							  </el-button>
							  <el-button type="danger" size="mini" @click="handleMissionDelete(row)">
							    删除
							  </el-button>
						    </template>
						</el-table-column>
					</el-table>
					
					<!-- 分页栏 -->
					<pagination :total="totalCounts" :page="listQuery.pageIndex" layout='sizes,prev, pager, next'
					  @pagination="handlePageChange">
					</pagination>
				</div>
			</el-col>
		</el-row>	
	</div>
</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {taskListPage,execTask,deleteTask,hideTask} from '@/api/task'
	import {mqttPushCarWork  } from '@/api/mqtt.js'
	  
	export default {
	  name: 'WorkManage',
	  components:{Pagination},
	  mounted(){
	      this.handleFilter()
	  },
	  data(){
		  return{
			  listLoading:false,
			  worklst:[],
			  totalCounts: 0,
			  listQuery: {
			    entityId: this.$store.getters['user/entityId'],
			    pageIndex: 1,
			    pageSize: 10,
			    params: {
			      car_id: undefined
			    },
				// carid:null,
			    fuzzySearch: true
			  },
		  }
	  },
	  methods:{
		  
		  handleFilter(){
			  this.listLoading = true
			  taskListPage( this.listQuery).then(res=>{
				  let rs = res.result
				  if(rs != null && rs == "0"){
					  this.listLoading = false
					  this.totalCounts = res.count
					  let data = res.data
					  if(data != null && data.length > 0){
						  this.worklst = data.map((item,index)=>{
							  item.missionName = item.missionName.indexOf('-') > 0 
								? item.missionName.substr(0,item.missionName.indexOf('-'))  : item.missionName
							  item.recordStatusStr = item.recordStatusStr == 1 ? '隐藏' :  '正常'	
							  return item	
						  })		 
					  }
				  }else{
					  this.listLoading = false
					  this.$message.error('获取失败');
				  }
			  })
		  },
		  handlePageChange(data){
			  this.listQuery.pageIndex = data.page
			  this.listQuery.pageSize = data.limit
			  this.handleFilter()
		  },
		  handleMissionExecute(row){
			  execTask(row.carId,row.id).then(res =>{
				  if(res.result == "200"){				  
					  this.$message.success(res.message);
				  }else{
					   this.$message.error(res.message);
				  }
			  })
		  },
		  handleMqttPush(row){
			 mqttPushCarWork(row.id,1,row.carId).then(res =>{
			 	if(res.result == '0'){
			 		this.$alert('推送成功！');
			 	}else{
			 		this.$alert('推送失败');
			 	}
			 })
		  },
		  handleMissionDelete(row){
		  		deleteTask(row.id).then(res =>{
		  			if(res.result == "200"){				  
		  				this.$message.success(res.message);
						this.handleFilter()
		  			}else{
		  				this.$message.error(res.message);
		  			}
		  		})
		  },
		  handleMissionHide(row,isUse){
		  		hideTask(row.id,isUse).then(res =>{
		  			if(res.result == "200"){				  
		  				this.$message.success(res.message);
		  						this.handleFilter()
		  			}else{
		  				this.$message.error(res.message);
		  			}
		  		})
		  }
	  }
	}
</script>

<style>
</style>
